import React, { useEffect, useState, useCallback, useMemo } from 'react'
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import ButtonCustom from 'components/ButtonCustom/ButtonCustom'
import { Grid } from '@mui/material';
import * as S from '../../style'
import Autocomplete from '@mui/material/Autocomplete';
import { RiCalendarEventFill } from 'react-icons/ri'
import InputAdornment from '@mui/material/InputAdornment';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import Modal from 'components/Modal/Modal';
import { getCategories, getSubCategories, createCategories, createFinancialInvoice } from 'utils/requests/financial';
import { getProjects } from 'utils/requests/project';
import { getPendingWithdrawPleas } from 'utils/requests/withdraw';
import moment from 'moment';
import 'moment/locale/pt-br';
import MaskMoney from 'components/Masks/MaskMoney';
import showToast from 'components/Toast/Toast';
import FormHelperText from '@mui/material/FormHelperText';
import { Formik, Form, useFormik } from 'formik';
import * as Yup from "yup";
import flatpickr from "flatpickr";
import "assets/theme/custom-flatpickr.css";
import { flatpickrOptions } from 'utils/utils';
import CloseIcon from '@mui/icons-material/Close';
import { sanitizeCurrencyValue } from 'utils/utils';
import { getAllClients } from 'utils/requests/leads';
import { approveWithdraw } from "utils/requests/withdraw";
import { IoAlertCircleOutline } from "react-icons/io5";
import { getInfluencerFinancial } from 'utils/requests/financial';
import { markBalanceAsPaid } from 'utils/requests/financial';

const OutboundForm = ({ refetch, closeModal, project }) => {
  moment.locale("pt-br")

  const [newCategory, setNewCategory] = useState();
  const [newCategoryOpen, setNewCategoryOpen] = useState(false);
  const [allCategories, setAllCategories] = useState();
  const [allSubCategories, setAllSubCategories] = useState();
  const [validateFields, setValidateFields] = useState(false);
  const [projects, setProjects] = useState();
  const [businesses, setBusinesses] = useState();
  const [pendingWithdrawals, setPendingWithdrawals] = useState([]);
  const [pendingBalances, setPendingBalances] = useState([]);
  const [selectedInfluencers, setSelectedInfluencers] = useState([]);
  const [originalSelectedInfluencers, setOriginalSelectedInfluencers] = useState([]);
  const [isLoadingPayments, setIsLoadingPayments] = useState(false);
  const [paymentState, setPaymentState] = useState({
    withdrawalSelected: false,
    balanceSelected: false,
    selectedInfluencerName: ''
  });
  const [openConfirmApprovalModal, setOpenConfirmApprovalModal] = useState(false);
  const [openPaymentWarningModal, setOpenPaymentWarningModal] = useState(false);
  const isPaymentSelected = useMemo(() => 
    paymentState.withdrawalSelected || paymentState.balanceSelected, 
    [paymentState.withdrawalSelected, paymentState.balanceSelected]
  );

  const formik = useFormik({
    initialValues: {
      value: '',
      date: '',
      description: '',
      bankAccount: '',
      projectRelated: project ?? null,
      category: null,
      subCategories: null,
      status: '',
      miscInfo: '',
      leadRelated: null,
      withdrawalRelated: null,
      balanceRelated: null,
    },

    validateOnChange: validateFields,
    validateOnBlur: false,

    validationSchema: Yup.object({
      value: Yup.string().required("Valor é um campo obrigatório"),
      date: Yup.string()
        .required("Data é um campo obrigatório")
        .test('not-future-when-paid', 'Data não pode ser futura quando o status é PAGO', function(value) {
          const { status } = this.parent;
          if (status === 'PAGO' && value) {
            const selectedDate = moment(value, 'DD/MM/YYYY HH:mm');
            const today = moment();
            return selectedDate.isSameOrBefore(today, 'day');
          }
          return true;
        }),
      description: Yup.string().required('Descrição é um campo obrigatório').min(4, 'Descrição precisa ter pelo menos 4 caracteres'),
      bankAccount: Yup.string(),
      projectRelated: Yup.object().notRequired(),
      category: Yup.object().required('Categoria é um campo obrigatório'),
      subCategories: Yup.array().notRequired().nullable(),
      status: Yup.string().required('Status é um campo obrigatório'),
      miscInfo: Yup.string(),
      leadRelated: Yup.object().nullable(),
      withdrawalRelated: Yup.object().nullable(),
      balanceRelated: Yup.object().nullable(),
    }),
    onSubmit: async (values) => {
      const unixDate = (date) => {
        return Number(moment(date, 'DD/MM/YYYY HH:mm').valueOf());
      };
      const newOutbound = {
        description: values.description,
        value: sanitizeCurrencyValue(values?.value),
        projectRelated: values.projectRelated?.id,
        category: values?.category?.id,
        subCategories: values?.subCategories?.map(sub => sub.id),
        businessStatus: values.status,
        miscInfo: values.miscInfo,
        dateInvoicedMs: unixDate(values.date),
        bankAccount: values.bankAccount,
        type: 'SAIDA',
        leadRelated: values.leadRelated?.id,
        withdrawalRelated: values.withdrawalRelated?.id,
        balanceRelated: values.balanceRelated?.id
      }
      Object.keys(newOutbound).forEach(key => {
        if (newOutbound[key] === "" || newOutbound[key] === undefined) {
          delete newOutbound[key];
        }
      });
      createFinancialInvoice(newOutbound).then(async (res) => {
        if (!res.message && !values.withdrawalRelated && !values.balanceRelated) { 
          showToast("Despesa criada com sucesso", "success");
          refetch(); 
          closeModal();
        };
          
        if (!res.message && values.withdrawalRelated) {
          const outboundRelated = res.id || res._id;

          await approveWithdraw(values.withdrawalRelated.id, outboundRelated).then((withdrawalRes) => {
            if (!withdrawalRes.message) {
              showToast("Despesa criada e saque aprovado com sucesso!", "success");
            } else {
              showToast("Erro na criação da despesa e aprovação do saque", "error");
            }
          });
          refetch(); 
          closeModal();
        };

        if (!res.message && values.balanceRelated) {
          const outboundRelated = res.id || res._id;

          await markBalanceAsPaid(values.balanceRelated.id, outboundRelated).then((balanceRes) => {
            if (!balanceRes.message) {
              showToast("Despesa criada e saldo pago com sucesso!", "success");
            } else {
              showToast("Erro na criação da despesa e pagamento do saldo", "error");
            }
          });
          refetch(); 
          closeModal();
        };

        if (res.message) { showToast("Falha na criação de despesa", "error") };
      });
    }
  });

  const fetchPendingPayments = useCallback(async (influencerIds, currentSubCategories) => {
    if (!influencerIds || influencerIds.length === 0) {
      setPendingWithdrawals([]);
      setPendingBalances([]);
      return;
    }

    setIsLoadingPayments(true);
    
    try {
      const paymentPromises = influencerIds.map(async (influencerId) => {
        const selectedInfluencer = currentSubCategories.find(sub => sub.influencer.id === influencerId);
        
        if (!selectedInfluencer?.influencer?.username) {
          return { withdrawals: [], balances: [] };
        }

        const username = selectedInfluencer.influencer.username;
        
        const [withdrawalsData, balancesData] = await Promise.all([
          getPendingWithdrawPleas(username, 100).catch(err => {
            console.error(`Error fetching withdrawals for ${username}:`, err);
            return { message: 'error' };
          }),
          getInfluencerFinancial(username, 0, 100).catch(err => {
            console.error(`Error fetching balances for ${username}:`, err);
            return { message: 'error' };
          })
        ]);

        const withdrawals = !withdrawalsData.message ? (withdrawalsData[0] || []) : [];
        const balances = !balancesData.message 
          ? (balancesData.financialEntries[0] || []).filter(entry => 
              entry.status === "PENDING" && !entry.withdrawPleaRelated
            )
          : [];

        return { withdrawals, balances };
      });

      const results = await Promise.all(paymentPromises);
      
      const allPendingWithdrawals = results.flatMap(result => result.withdrawals);
      const allPendingBalances = results.flatMap(result => result.balances);

      setPendingWithdrawals(allPendingWithdrawals);
      setPendingBalances(allPendingBalances);
      
    } catch (error) {
      console.error('Error fetching pending payments:', error);
      showToast("Erro ao buscar pagamentos pendentes", "error");
      setPendingWithdrawals([]);
      setPendingBalances([]);
    } finally {
      setIsLoadingPayments(false);
    }
  }, []);

  const handlePaymentSelection = useCallback((type, value, relatedField) => {
    if (value) {
      if (!isPaymentSelected) {
        setOriginalSelectedInfluencers(formik.values.subCategories);
      }
      
      const valueInReais = (value?.value && typeof value.value === 'number') ? value.value / 100 : 0;
      formik.setFieldValue('value', valueInReais.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      }));
      formik.setFieldValue('status', 'PAGO');
      formik.setFieldValue(relatedField, value);
      
      setPaymentState(prev => ({
        ...prev,
        [type]: true,
        [type === 'withdrawalSelected' ? 'balanceSelected' : 'withdrawalSelected']: false
      }));
      
      if (value.influencerRelated?.id) {
        const relatedInfluencer = formik.values.subCategories.find(sub => 
          sub.influencer.id === value.influencerRelated.id
        );
        
        if (relatedInfluencer) {
          if (formik.values.subCategories.length > 1) {
            setPaymentState(prev => ({
              ...prev,
              selectedInfluencerName: value.influencerRelated.name || relatedInfluencer.name
            }));
            setOpenPaymentWarningModal(true);
          }
          formik.setFieldValue('subCategories', [relatedInfluencer]);
        }
      }
    } else {
      formik.setFieldValue('value', '');
      formik.setFieldValue(relatedField, null);
      
      setPaymentState(prev => ({
        ...prev,
        [type]: false,
        selectedInfluencerName: ''
      }));
      
      const otherType = type === 'withdrawalSelected' ? 'balanceSelected' : 'withdrawalSelected';
      if (!paymentState[otherType]) {
        setPaymentState({
          withdrawalSelected: false,
          balanceSelected: false,
          selectedInfluencerName: ''
        });
        
        if (originalSelectedInfluencers.length > 0) {
          formik.setFieldValue('subCategories', originalSelectedInfluencers);
        }
      }
    }
  }, [formik, isPaymentSelected, originalSelectedInfluencers, paymentState]);

  const getAllCategories = async () => {
    const data = await getCategories(["SAIDA"]);
    if (!data.statusCode) {
      const categoriesArray = data;
      categoriesArray.push({ name: "Criar nova categoria +", id: "Criar nova categoria +" });
      setAllCategories(categoriesArray);
    };
  };

  const getAllSubCategories = async () => {
    const data = await getSubCategories(["SAIDA"]);
    if (!data.statusCode) {
      setAllSubCategories(data);
    };
  };

  const fetchProjects = async () => {
    const data = await getProjects();
    if (!data.message) {
      setProjects(data);
    };
  };

  const fetchBusinesses = async () => {
    const data = await getAllClients();
    if (!data.message) {
      setBusinesses(data);
    };
  };

  const handleNewCategoryClose = () => {
    setNewCategoryOpen(false);
    formik.setFieldValue('category', null);
    setNewCategory('');
  };

  const cancelApproval = () => {
    setOpenConfirmApprovalModal(false);
  };

  const confirmApproval = () => {
    setOpenConfirmApprovalModal(false);
    setValidateFields(true);
    formik.submitForm();
  }

  useEffect(() => {
    if (!projects) {
      fetchProjects();
    };
    if (!businesses) {
      fetchBusinesses();
    };
    getAllCategories();
    getAllSubCategories();
  }, []);

  useEffect(() => {
    if (formik?.values?.category?.name === 'Criar nova categoria +') {
      setNewCategoryOpen(true);
    };
  }, [formik.values.category]);

  useEffect(() => {
    if (formik.values.subCategories && formik.values.subCategories.length > 0) {
      const influencerIds = formik.values.subCategories.map(inf => inf.influencer.id);
      setSelectedInfluencers(formik.values.subCategories);
      
      if (!isPaymentSelected) {
        setOriginalSelectedInfluencers(formik.values.subCategories);
      }
      
      fetchPendingPayments(influencerIds, formik.values.subCategories);
    } else {
      setSelectedInfluencers([]);
      
      if (!isPaymentSelected) {
        setOriginalSelectedInfluencers([]);
      }
      
      setPendingWithdrawals([]);
      setPendingBalances([]);
    }
  }, [formik.values.subCategories, fetchPendingPayments, isPaymentSelected]);

  useEffect(() => {
    if (isPaymentSelected &&  allCategories) {
      const saqueCategory = allCategories.find(cat => cat.name === 'SAQUE');
      if (saqueCategory) {
        formik.setFieldValue('category', saqueCategory);
      }
    }
  }, [isPaymentSelected, allCategories]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const onSaveNewCategory = async (name) => {
    await createCategories(name, "MAIN", 'SAIDA').then((res) => {
      if (!res.message) {
        showToast("Categoria criada com sucesso", "success");
        getAllCategories();
        formik.setFieldValue('category', res);
        setNewCategory('');
        setNewCategoryOpen(false)
      };
      if (res.message) {
        showToast("Falha na criação de categoria", "error")
      };
    });
  };

  const handleStatusChange = (event) => {
    if (!isPaymentSelected) {
      formik.setFieldValue('status', event.target.value);
    }
  };

  flatpickr("#date", flatpickrOptions('date', formik.setFieldValue, formik.setFieldTouched));
  flatpickr(".paymentDate", flatpickrOptions('paymentDate', formik.setFieldValue, formik.setFieldTouched));

  return (
    <>
      <Formik initialValues={formik.initialValues} validationSchema={formik.validationSchema} onSubmit={formik.handleSubmit} validateOnChange validateOnBlur validateOnMount>
        <Form style={{ width: '100%' }}>
          <Grid container>
            <Grid container flexDirection='column' gap='20px' marginTop='30px'>
              <Grid container justifyContent='space-between'>
                <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                  <S.Input
                    name='description'
                    hiddenLabel
                    type='text'
                    placeholder="Título (Descrição)"
                    fullWidth
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                    error={Boolean(formik.errors.description) && formik.touched.description}
                    helperText={formik.touched.description ? formik.errors.description : false}
                  />
                </S.InputGrid>
                <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                  <S.Input
                    name='value'
                    hiddenLabel
                    placeholder={"Valor (R$)"}
                    fullWidth
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.value}
                    InputProps={{ 
                      inputComponent: MaskMoney,
                      readOnly: isPaymentSelected
                    }}
                    error={Boolean(formik.errors.value) && formik.touched.value}
                    helperText={formik.touched.value ? formik.errors.value : false}
                  />
                </S.InputGrid>
              </Grid>
              <Grid container justifyContent='space-between'>
                <S.DateInputGrid item id='date' xs={12} md={5.5} xl={5.5}>
                  <S.Input
                    name='date'
                    hiddenLabel
                    type='text'
                    placeholder="Data"
                    fullWidth
                    value={formik.values.date}
                    data-input
                    autoComplete='off'
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <RiCalendarEventFill />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position='end'>
                          <CloseIcon onClick={() => formik.setFieldValue('date', '')} sx={{ cursor: "pointer", "&:hover": { color: "#E22B00" } }} />
                        </InputAdornment>
                      )
                    }}
                    error={Boolean(formik.errors.date) && formik.touched.date}
                    helperText={formik.touched.date ? formik.errors.date : false}
                  />
                </S.DateInputGrid>
                <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                  <S.Input
                    name='bankAccount'
                    hiddenLabel
                    type='text'
                    placeholder="Conta Bancária"
                    fullWidth
                    onChange={formik.handleChange}
                    value={formik.values.bankAccount}
                  />
                </S.InputGrid>
              </Grid>
              <Grid container justifyContent='space-between'>
                <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                  <Autocomplete
                    limitTags={10}
                    disablePortal
                    readOnly={project?.id ?? false}
                    value={formik.values.projectRelated ? formik.values.projectRelated : null}
                    onChange={(e, value) => {
                      formik.setFieldValue('projectRelated', value ? value : '')

                      if (value && value.leadsRelated) {
                        formik.setFieldValue('leadRelated', value.leadsRelated);
                      }
                    }}
                    options={projects ? projects[0] : []}
                    sx={{ width: "100%" }}
                    getOptionLabel={(option) => option.title}
                    renderInput={(params) => <S.Input {...params} placeholder='Projeto' />}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                </S.InputGrid>
                <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                  <Autocomplete
                    limitTags={10}
                    disablePortal
                    value={formik.values?.leadRelated ? formik.values?.leadRelated : null}
                    onChange={(e, value) => {
                      if (!formik.values.projectRelated) {
                        formik.setFieldValue('leadRelated', value);
                      }
                    }}
                    options={businesses ? businesses[0] : []}
                    sx={{ width: "100%" }}
                    getOptionLabel={(option) => option.businessName}
                    renderInput={(params) => <S.Input {...params} placeholder='Empresa' />}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                </S.InputGrid>
              </Grid>
              <Grid container justifyContent='space-between'>
                <>
                  <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                    <Autocomplete
                      limitTags={10}
                      name='category'
                      disablePortal
                      value={formik.values.category ? formik.values.category : null}
                      onChange={(e, value) => {
                        formik.setFieldTouched('category')
                        formik.setFieldValue('category', value ? value : '')
                      }}
                      readOnly={isPaymentSelected}
                      options={allCategories ? allCategories : []}
                      sx={{ width: "100%" }}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => <S.Input {...params} error={Boolean(formik.errors.category)} placeholder='Categoria' />}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                    />
                    {(Boolean(formik.errors.category) && formik.touched.category) && <FormHelperText sx={{ color: "#f44336", marginLeft: "14px" }}>Categoria é um campo obrigatório</FormHelperText>}
                  </S.InputGrid>
                  <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                    <Autocomplete
                      limitTags={10}
                      name='subCategories'
                      disablePortal
                      disableCloseOnSelect
                      multiple
                      disabled={isPaymentSelected}
                      value={formik.values.subCategories ? formik.values.subCategories : []}
                      onChange={(e, value) => {
                        formik.setFieldValue('subCategories', value)
                      }}
                      id="combo-box-demo"
                      options={allSubCategories ? allSubCategories : []}
                      sx={{ width: "100%" }}
                      renderInput={(params) => <S.Input {...params} placeholder='Influencer' />}
                      getOptionLabel={(option) => option.name}
                      isOptionEqualToValue={(option, value) => option.name === value.name}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      )}
                    />
                  </S.InputGrid>
                </>
              </Grid>
              
              {selectedInfluencers.length > 0 && (
                <Grid container justifyContent='space-between'>
                  <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                    <Autocomplete
                      limitTags={10}
                      disablePortal
                      value={formik.values.withdrawalRelated ? formik.values.withdrawalRelated : null}
                      disabled={paymentState.balanceSelected}
                      onChange={(e, value) => {
                        handlePaymentSelection('withdrawalSelected', value, 'withdrawalRelated');
                      }}
                      options={pendingWithdrawals || []}
                      sx={{ width: "100%" }}
                      ListboxProps={{ style: { maxHeight: "180px", overflowY: "auto" }}}
                      getOptionLabel={(option) => {
                        const valueInReais = option.value / 100;
                        const formattedValue = valueInReais.toLocaleString('pt-BR', {
                          style: 'currency', 
                          currency: 'BRL'
                        });
                        
                        let description = "";
                        if (option.balanceRelated && option.balanceRelated.length > 0) {
                          description = option.balanceRelated[0].description || "";
                        }
                        
                        let influencerName = "";
                        if (option.influencerRelated && option.influencerRelated.name) {
                          influencerName = option.influencerRelated.name;
                        }

                        let type = "";
                        if (option.type === "FUTURE_BALANCE") {
                          type = "Saldo Futuro";
                        } else {
                          type = "Saldo Atual"
                        }

                        return selectedInfluencers.length > 1 
                          ? `${influencerName.toUpperCase()}: ${description} - ${formattedValue} (${type})`
                          : `${description} - ${formattedValue} (${type})`;
                      }}
                      renderInput={(params) => <S.Input {...params} placeholder='Saques Solicitados' />}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                    />
                  </S.InputGrid>
                  <S.InputGrid item xs={12} md={5.5} xl={5.5}>
                    <Autocomplete
                      limitTags={10}
                      disablePortal
                      value={formik.values.balanceRelated ? formik.values.balanceRelated : null}
                      disabled={paymentState.withdrawalSelected}
                      onChange={(e, value) => {
                        handlePaymentSelection('balanceSelected', value, 'balanceRelated');
                      }}
                      options={pendingBalances || []}
                      sx={{ width: "100%" }}
                      ListboxProps={{ style: { maxHeight: "180px", overflowY: "auto" }}}
                      getOptionLabel={(option) => {
                        const valueInReais = option.value / 100;
                        const formattedValue = valueInReais.toLocaleString('pt-BR', {
                          style: 'currency', 
                          currency: 'BRL'
                        });
                        
                        let description = "";
                        if (option && option.description) {
                          description = option.description || "";
                        }
                        
                        let influencerName = "";
                        if (option.influencerRelated && option.influencerRelated.name) {
                          influencerName = option.influencerRelated.name;
                        }

                        let type = "";
                        if (option.type === "FUTURE_BALANCE") {
                          type = "Saldo Futuro";
                        } else {
                          type = "Saldo Atual"
                        }

                        return selectedInfluencers.length > 1 
                          ? `${influencerName.toUpperCase()}: ${description} - ${formattedValue} (${type})`
                          : `${description} - ${formattedValue} (${type})`;
                      }}
                      renderInput={(params) => <S.Input {...params} placeholder='Saldos Pendentes' />}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                    />
                  </S.InputGrid>
                </Grid>
              )}
              
              <Grid container>
                <S.InputGrid item md={12} xl={12}>
                  <S.Input
                    hiddenLabel
                    name='miscInfo'
                    type='text'
                    placeholder="Observações"
                    fullWidth
                    onChange={formik.handleChange}
                    value={formik.values.miscInfo}
                  />
                </S.InputGrid>
              </Grid>
              <Grid container justifyContent='space-between'>
                <Grid item md={5.5} xl={5.5}>
                  <FormControl>
                    <FormLabel sx={{ color: "#fff" }}>Status:</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={formik.values.status}
                      onChange={handleStatusChange}
                    >
                      {Boolean(formik.errors.status) && formik.touched.status && <FormHelperText sx={{ color: "#f44336" }}>Status é um campo obrigatório</FormHelperText>}
                      <Grid container gap='30px' sx={{ marginLeft: "20px" }}>
                        <FormControlLabel value="PAGO" control={<Radio />} label="Pago" />
                        <FormControlLabel 
                          value="PENDENTE" 
                          control={<Radio />} 
                          label="Pendente" 
                          disabled={isPaymentSelected}
                          sx={{
                            opacity: isPaymentSelected ? 0.4 : 1,
                            '& .MuiFormControlLabel-label': {
                              color: isPaymentSelected ? '#666' : 'inherit'
                            }
                          }}
                        />
                      </Grid>
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent='flex-end'>
            <ButtonCustom
              label='Salvar'
              type='button'
              sx={{ width: "150px", fontSize: "18px", fontWeight: "500" }}
              onClick={() => {
                if (isPaymentSelected) {
                  setOpenConfirmApprovalModal(true);
                } else {
                  setValidateFields(true);
                  formik.submitForm();
                }
              }}
              data-cy="save-financial-expanse"
            />
          </Grid>
        </Form>
      </Formik>
      <Modal
        open={newCategoryOpen}
        onClose={handleNewCategoryClose}
        size={"sm"}
      >
        <Grid container flexDirection='column' gap='30px'>
          <p>Nova Categoria</p>
          <S.InputGrid item xl={12}>
            <S.Input
              hiddenLabel
              name='newCategory'
              type='text'
              placeholder="Nome da Categoria"
              fullWidth
              onChange={(event) => setNewCategory(event.target.value)}
              value={newCategory}
            />
          </S.InputGrid>
          <Grid container justifyContent='flex-end'>
            <ButtonCustom label='Salvar' onClick={() => onSaveNewCategory(newCategory)} sx={{ width: "100px", height: "40px !important", fontSize: "18px", fontWeight: "500" }} />
          </Grid>
        </Grid>
      </Modal>
      <Modal size="md" open={openConfirmApprovalModal} onClose={() => cancelApproval()} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Grid container flexDirection="column" gap="20px">
          <p style={{ fontSize: "24px" }}>Confirmar criação de despesa</p>
          <p style={{ fontSize: "18px" }}>{paymentState.withdrawalSelected ? "Deseja criar esta despesa à partir do saque selecionado?" : "Deseja criar esta despesa à partir do saldo selecionado?"}</p>
        </Grid>
        <S.AlertGrid container gap="5px">
          <IoAlertCircleOutline color="red" style={{ alignSelf: "center" }} />
          <p className="subtitleDetails reminderDetails">Lembrete:</p>
          <p className="subtitleDetails">{paymentState.withdrawalSelected ? "O saque será aprovado e não poderá ser editado/excluído." : "O saldo será pago e não poderá ser editado/excluído."}</p>
        </S.AlertGrid>
        <Grid container gap="15px" justifyContent="center" mt="30px">
          <Grid item lg={3}>
            <ButtonCustom
              label="Cancelar"
              onClick={() => cancelApproval()}
              sx={{ background: "linear-gradient(180deg, #818181 0%, #2a2020 155.15%)" }}
            ></ButtonCustom>
          </Grid>
          <Grid item lg={3}>
            <ButtonCustom label="Confirmar" onClick={() => confirmApproval()}></ButtonCustom>
          </Grid>
        </Grid>
      </Modal>
      <Modal size="md" open={openPaymentWarningModal} onClose={() => setOpenPaymentWarningModal(false)} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Grid container flexDirection="column" gap="20px" alignItems="center">
          <IoAlertCircleOutline size={48} color="#FFA500" />
          <p style={{ fontSize: "24px", textAlign: "center" }}>Pagamento Selecionado</p>
          <p style={{ fontSize: "18px", textAlign: "center" }}>
            Pagamento de <strong>{paymentState.selectedInfluencerName}</strong> selecionado, os outros influencers foram removidos.
          </p>
          <Grid container justifyContent="center" mt="20px">
            <Grid item lg={3}>
              <ButtonCustom 
                label="Entendi" 
                onClick={() => setOpenPaymentWarningModal(false)}
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  )
}

export default OutboundForm